import { useDispatch, useSelector } from "react-redux";
import {
    fetchingData,
    fetchDataSuccess,
    fetchDataFail,
    setCurrentPage,
    setRowsPerPage,
    setSearchTerm,
    setUserType,
    setStartDate,
    setEndDate,
} from './_reducers';
import { API_URL } from "../../../configs/_api";
import ApiRequest from "../../../utils/apiRequest";

const useAnalyticsLogActions = () => {
    const dispatch = useDispatch();

    const currentPage = useSelector(state => state.analyticslog.currentPage);
    const rowsPerPage = useSelector(state => state.analyticslog.rowsPerPage);
    const searchTerm = useSelector(state => state.analyticslog.searchTerm);
    const userType = useSelector(state => state.analyticslog.userType);
    const start_date = useSelector(state => state.analyticslog.start_date);
    const end_date = useSelector(state => state.analyticslog.end_date);
    
    function fetchLogList() {
        dispatch(fetchingData());
        const url = `${API_URL.Analytics}/log?page_no=${currentPage+1}&page_size=${rowsPerPage}&search_term=${searchTerm}&user_type=${userType}&date_from=${start_date ?? ''}&date_to=${end_date ?? ''}`;
        ApiRequest.get(url)
        .then(res => {
            const data = res.data.payload.data;
            const { total_items } = res.data.payload.metadata;
            dispatch(fetchDataSuccess({data, total_items}));
        })
        .catch(err => {
            const errMsg = err.response?.data.errors.message || err.message;
            dispatch(fetchDataFail(errMsg));
        })
    }

    function changeCurrentPage(pageNo) {
        dispatch(setCurrentPage(pageNo));
    }

    function changeRowsPerPage(rowsPerPage) {
        dispatch(setCurrentPage(0));
        dispatch(setRowsPerPage(rowsPerPage));
    }

    function changeSearchTerm(st) {
        dispatch(setSearchTerm(st));
    }

    function changeUserType(st) {
        dispatch(setUserType(st));
    }

    function changeStartDate(date) {
        dispatch(setStartDate(date));
    }

    function changeEndDate(date) {
        dispatch(setEndDate(date));
    }

    return {
        fetchLogList,
        changeCurrentPage,
        changeRowsPerPage,
        changeSearchTerm,
        changeUserType,
        changeStartDate,
        changeEndDate
    }
}

export default useAnalyticsLogActions;